import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserQueryKeys } from '@enums/react-query-keys';
import { User } from '@interfaces/models/user';
import UserService from '@services/user-service';

const useUpdateDeleteCardsPermission = (userId: User['id']) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (deleteCards: boolean) => UserService.updateDeleteCardsPermission(userId, deleteCards),
    onMutate: async (deleteCards: boolean) => {
      await queryClient.cancelQueries({ queryKey: [UserQueryKeys.USER] });
      const previousUser = queryClient.getQueryData<User | null>([UserQueryKeys.USER]);

      queryClient.setQueryData<User | null>([UserQueryKeys.USER], (old) =>
        old ? { ...old, hasDeleteCardsPermission: deleteCards } : old,
      );

      return { previousUser };
    },
    onError: (_error, _variables, context) => {
      if (context?.previousUser !== undefined) {
        queryClient.setQueryData([UserQueryKeys.USER], context.previousUser);
      }
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: [UserQueryKeys.USER] }),
  });
};

export default useUpdateDeleteCardsPermission;
